import { render, staticRenderFns } from "./ESDetailHeader.vue?vue&type=template&id=7c58980f&"
import script from "./ESDetailHeader.vue?vue&type=script&lang=js&"
export * from "./ESDetailHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports